const translations = {
  en: {
    welcomeLine1: "Welcome to RioRegie!",
    welcomeLine2: "You're now connected as",
    welcomeLine3: "Start chatting with your AI assistant...",
    send: "Send",
    submit: "Submit",
    selectSubtasks: "Select subtasks",
    selectSubtasksLabel: "Select subtasks:",
    selected: "selected",
    selectedVariantLabel: "Selected variant: {value}",
    selectedSubtasksLabel: "Selected subtasks: {value}",
    definedTaskSelected: "I see you selected a predefined task",
    subtaskSelectionInstruction: "Please select all the tasks you did from the dropdown list, or describe them in detail in the chat. If you are not sure, don't worry. you will be able to add and delete them later.",
    wellDefinedTasksListHeader: "Here are the well-defined tasks you can use:",
    wellDefinedTasksListFooter: "You can use these task names directly when submitting your work.",
    wellDefinedTasksAre: "The well defined tasks are:",
    changeLanguage: "Change language",
    toggleTheme: "Toggle theme",
    assistant: "Assistant",
    typeMessage: "Type your message...",
    employee: "Employee",
    online: "Online",
    todaysTasks: "Today's tasks and conversation",
    logout: "Logout",
    settings: "Settings",
    assistantWelcome: "Hello! I'm your AI assistant. How can I help you today?",
    assistantProjectHelp: "Of course! I can help you with that. What specific questions do you have about the project management system?",
    assistantStepByStep: "To create a new project, go to the Projects tab and click \"New Project\". Then you can add team members by clicking the \"Add Members\" button. Would you like me to walk you through the process step by step?",
    assistantDefault: "Thank you for your message! I'll get back to you shortly with a detailed response.",
    chatSubmittedNotice: "This chat has been submitted and cannot be changed anymore. If you'd like to submit more tasks, do it in a new chat window. If you want to add a comment for your manager to view later, type it in the chat and type 'submit' again to confirm.",
    multipleVariantsFound: "Multiple variants found. Please select the correct one:",
    extractedValues: "Extracted Values:",
    extractedKeywords: "Extracted Keywords:",
    normalizedRequest: "Normalized request:",
    amount: "Amount",
    billing: "Billing",
    conversationWelcome: "Hello! How can I help you today?",
    conversationTaskPrompt: "Tell me about your task. What did you do?",
    conversationSomethingElse: "I understand your question. For now, we focus on tasks. Would you like to submit a task?",
    conversationGoodbye: "Thank you! Goodbye!",
    // Dialogue step messages
    conv_welcome: "Hello! How can I help you today?",
    conv_help: "Hello! 👋 I'm your <strong>virtual assistant</strong>, here to help you submit your work tasks.<br><br>You can tell me about the tasks you completed during your workday.<br><br>➡️ Please keep it simple: <em>one task per sentence</em> works best (though multiple tasks at once are also fine).<br><br>After you enter your task(s), I'll extract the important details, rephrase them into clear sentences, and ask you to confirm. I may also ask a few follow-up questions.<br><br>✅ At the end, your tasks will be displayed in a <strong>table</strong> for final confirmation.<br><br>Once you approve, the chat will close and a new one will start — keeping everything clear and organized.<br><br>✨ In the <strong>top right corner</strong>, you'll find 3 useful options:<br>- 🌍 Click the <strong>language button</strong> to switch between English and Dutch.<br>- 🔊 Click the <strong>speaker button</strong> to have me read the messages out loud.<br>- 🌙☀️ Click the <strong>moon/sun icon</strong> to switch between dark and light mode.<br><br>🎤 If you prefer speaking instead of typing, click the <strong>microphone button</strong> to start talking, and click it again when you're done. You may need to enable microphone access in your browser settings.<br><br>🔄 <strong>Need to start over?</strong> You can reset the conversation at any time by typing: <em>start over</em>, <em>try again</em>, <em>reset</em>, <em>opnieuw instellen</em>, <em>opnieuw beginnen</em>, <em>cancel</em>, <em>annuleren</em>, <em>TA</em>, or <em>OB</em>.<br><br>📞 If you have any questions or want to report a bug, please contact <strong>+31 6 XXXXXXXX</strong>.",
    conv_task_request: "Please describe the tasks you completed.",
    conv_task_simple_splitting_and_confirmation: "I've processed your tasks. Here's what I found:",
    conv_task_processing: "Processing your tasks...",
    are_there_more_tasks: "We already processed those tasks. Do you have more tasks to submit?",
    assignement_additional_comments:
      "Do you have any additional comments about this assignment? Type them here, or confirm there is nothing to add by typing OK.",
    final_confirmation: "Please confirm that all the above tasks are correct before we proceed.",
    user_requests_correction: "I understand you want to make some changes.",
    conv_something_else: "This feature is in development. For urgent matters, please contact +31 6 XXXXX",
    conv_bye: "Thank you! Goodbye!",
    userRequestsCorrectionInstruction: "If you would like to delete a task, please say which task should be deleted. If you want to add a task, please do so in a new conversation. If you want to change the amount, number of employees, or location please indicate what change should be made, and for which task.",
    variantSelectionPrompt: "Which option applies to your task?",
    billingUnitHours: "The billing unit for this task is hours.\nHow many hours were spent on this task?",
    billingUnitMeters: "The billing unit for this task is meters.\nHow many meters were worked on?",
    billingUnitPieces: "The billing unit for this task is pieces.\nHow many pieces were used?",
    billingUnitGeneric: "How many units were used for this task?",
    billingUnitFallback: "How much was used for this task?",
    // Specific question rules
    billingUnitHourEmployee: "The billing unit for this task is hours.\nHow long was the employee working for?",
    billingUnitHourTeam: "The billing unit for this task is hours.\nHow long was the team working for?",
    billingUnitHourEquipment: "The billing unit for this task is hours.\nHow long did you use this equipment for?",
    billingUnitStTreeRemove: "The billing unit for this task is pieces.\nHow many trees have you removed?",
    billingUnitStPipeRemove: "The billing unit for this task is pieces.\nHow many pipes have you removed?",
    billingUnitStPipeInstall: "The billing unit for this task is pieces.\nHow many pipes have you installed?",
    billingUnitMPipeRemove: "The billing unit for this task is meters of pipe.\nHow many meters of pipe have you removed?",
    billingUnitMPipeInstall: "The billing unit for this task is meters of pipe.\nHow many meters of pipe have you installed?",
    billingUnitMGeneric: "The billing unit for this task is meters.\nHow many meters were used/processed?",
    billingUnitArea: "The billing unit for this task is area.\nWhat was the area?",
    billingUnitVolume: "The billing unit for this task is volume.\nWhat was the volume?",
    taskCompleted: "Task completed successfully!",
    processingNextTask: "Processing next task: {taskDescription}",
    processingTaskNow: "I'm processing the task \"{taskDescription}\" now.",
    chooseItemMatchesTask: "Please choose the item that matches your task",
    conversationSubmitted: "Conversation submitted",
    tasksCompletedSingle: "I see you did 1 task:",
    tasksCompletedMultiple: "I see you did {count} tasks:",
    confirmOrRetypeTasks: "Please confirm or retype your tasks.",
    conversationSubmittedNotice: "This conversation has been submitted. You can start a new one.",
    location_clarification: "Where was this task completed? Please provide an exact address.",
    /** Stored on tasks when the work address comes from the assignment (no user prompt). */
    taskLocationFromAssignementFallback: "Work location (assignment)",
    something_else_message: "I'm sorry, I didn't understand that. Please try again.",
    // Task confirmation messages
    thankYouForSubmitting: "Thank you for submitting your tasks. Please verify if the summary below is correct:",
    noCompletedTasksFound: "No completed tasks found to display.",
    doYouConfirm: "Do you confirm?",
    gotThat: "Got that!",
    // Task summary UI
    taskSummary: "Task Summary",
    reviewCompletedTasks: "Review the completed tasks below:",
    // Measurement terms
    diameter: "diameter",
    height: "height", 
    depth: "depth",
    length: "length",
    area: "area",
    size: "size",
    // Speech-to-text
    startVoiceInput: "Start voice input",
    stopListening: "Stop recording",
    voiceInputNotSupported: "Microphone access denied. Please allow microphone access to use voice input.",
    processingAudio: "Processing audio...",
    audioUploadError: "Error processing audio file. Please try again.",
    recording: "Recording... Click to stop",
    // Emergency submission
    emergency_submit_message: "You used emergency submission function. Your task will be submitted as is. Thank you!",
    // Abort confirmation
    abort: "Abort conversation",
    areYouSureYouWantToAbort: "Are you sure you want to abort?",
    // Task modification confirmations
    deleteTaskConfirmation: "I understand you want to delete a task. Please specify which task should be deleted.",
    changeTaskConfirmation: "I understand you want to change a task. Please specify what changes should be made and for which task.",
    // Feature development messages
    featureInDevelopment: "This feature is currently in development and will be functional in the next version! For now, assume we understood your feedback even though you can't see the change.",
    pleaseConfirmToContinue: "Please type in \"I confirm\" to go forward.",
    // Conversation cancellation
    conversationCancelled: "You requested this conversation to be cancelled. Please start in a new window!",
    // Missing state keys
    delete_a_task: "I understand you want to delete a task. Please specify which task should be deleted.",
    change_a_task: "I understand you want to change a task. Please specify what changes should be made and for which task.",
    processing_options_selection: "Your task is being processed...",
    no_tasks_found: "I couldn't find any tasks in your message. Try describing your task more clearly.",
    variant_selection: "Which option applies to your task?",
    amount_clarification: "How much was used for this task?",
    abort_confirmation: "Are you sure you want to abort?",
    abortCancelled: "Abort cancelled. Let's continue where we left off.",
    abortConfirmed: "Okay, I will stop this conversation. You can start a new one whenever you're ready.",
    task_completed: "Task completed successfully!",
    task_aborted: "Task processing was aborted.",
    // Well-defined tasks
    well_defined_task_property_connection: "property connection",
    well_defined_task_manhole_replacement: "manhole replacement",
    well_defined_task_manhole_connection_replacement: "manhole connection replacement",
    well_defined_task_hole_subsidence: "hole-subsidence",
    well_defined_task_main_sewer: "main sewer",
    well_defined_task_drainage: "drainage",
    well_defined_task_clean_manholes: "clean manholes",
    // Subtasks (keep numeric IDs as part of the key)
    subtask_141: "Breaking up asphalt",
    subtask_142: "Breaking up concrete paving stones",
    subtask_143: "Breaking up paving bricks",
    subtask_144: "Breaking up concrete tiles",
    subtask_145: "Breaking up curb edge",
    subtask_146: "Breaking up the gutter",
    subtask_147: "Additional work",
    subtask_149: "Breaking up foundation",
    subtask_147110: "Remove soil from paving material",
    subtask_151: "Installing, Applying, Removing, maintaining open drainage",
    subtask_181: "Removing Concrete and PVC pipes",
    subtask_182: "Removing Drainage Pipes",
    subtask_183: "Removing/Maintaining Manholes / wells",
    subtask_184: "Removing/Maintaining catch basins/gullies",
    subtask_185010: "Removal of brick masonry retaining wall",
    // Task-specific subtasks
    subtask_154: "installation of Shut-off valves",
    subtask_155: "Flushing drainage pipes",
    subtask_163: "Soil Excavation (House and manhole connections, pressure pipe, drainage)",
    subtask_164: "Soil Excavation (Formwork - Shoring trench sewer, double sided with different heights)",
    subtask_1558: "Clean catch basins/gullies",
    // New subtasks
    subtask_24: "Installing Drainage manhole / wells",
    subtask_211: "installing piping - pipes",
    subtask_212: "Installing piping - House and manhole / well connections",
    subtask_214: "installation of drainage pipes",
    subtask_221: "Installing piping - Concrete manhole / wells",
    subtask_222: "Installing Piping - Plastic wells",
    subtask_223: "Installing piping - manhole / wells adjustments",
    subtask_224: "Installing piping - Well edges",
    subtask_228010: "Measuring wells",
    subtask_231: "processing sand and soil - Main sewer and culverts",
    subtask_232: "processing sand/soil - House and Drainage manhole / wells connection, pressure pipe",
    subtask_233: "Drainage guidance - filling trenches",
    subtask_243: "Attaching odor seal and replacing cover pin",
    subtask_251: "Sewer inspection - pipes",
    subtask_260010: "Fixing and repairing leaks and other damage within sewer systems",
    subtask_343: "Installation of Concrete tiles",
    subtask_344: "Installation of street bricks",
    subtask_345: "Installation of concrete paving stone",
    // Subtask processing messages
    processingSubtaskNow: "Processing task \"{taskDescription}\" now. Please provide requested information.",
    pleaseProvideAmountForTask: "Please provide the amount for your task (unit: {unit})",
    pleaseSelectVariantForTask: "Please select a variant for \"{taskDescription}\":",
    pleaseSelectVariantForSubtask: "Please select a variant for subtask {subtaskId}:",
    pleaseSelectMostFittingDescription: "Please select a most fitting description for \"{subtaskDescription}\":",
    pleaseSelectMostFittingDescriptionForSubtask: "Please select a most fitting description for subtask {subtaskId}:",
    taskIdDescription: "Task ID: {taskId}\nDescription: {description}\nSimilarity: 1.0",
    couldYouPleaseClarify: "Could you please clarify what you'd like to do?",
    taskSplittingError: "Sorry, I had trouble processing your tasks: {error}. Please try again.",
    // Table headers
    taskDescription: "Task Description",
    id: "ID",
    billableUnit: "b. unit",
    billableAmount: "b. amount",
    employees: "Employees",
    location: "Location",
    removeTask: "Remove task",
    noCompletedTasksToDisplay: "No completed tasks to display.",
    // Text-to-speech
    textToSpeechOnlyAvailableInDutch: "Text-to-speech only available in Dutch",
    disableTextToSpeech: "Disable text-to-speech",
    enableTextToSpeech: "Enable text-to-speech",
    // Invoice generation
    failedToGenerateInvoice: "Failed to generate invoice",
    errorGeneratingInvoice: "Error generating invoice",
    // Accessibility
    closeSidebar: "Close sidebar",
    assignementAddressTitle: "Assignment address",
    assignementAddressPrompt:
      "Enter the work address for this assignment. It will be used as the default location for tasks in this assignment.",
    assignementAddressPlaceholder: "Street, number, postal code, city",
    assignementSaveAddress: "Save",
    assignementCancel: "Cancel",
    assignementNew: "New assignment",
    assignementMarkComplete: "Mark assignment complete",
    assignementCompleted: "Completed",
    assignementChats: "Chats",
    assignementUnassigned: "Other (no assignment)",
    assignementNumber: "Assignment {n}",
    addCommentsOnly: "Add comments only",
    // Variant selector
    defaultOption: "Default Option",
    // Server busy message
    serverBusyRetrying: "The server is very busy right now, it may take more time than usual. Please wait...",
    // Add more keys as needed
  },
  nl: {
    welcomeLine1: "Welkom bij RioRegie!",
    welcomeLine2: "Je bent nu verbonden als",
    welcomeLine3: "Begin met chatten met je AI-assistent...",
    send: "Versturen",
    submit: "Indienen",
    selectSubtasks: "Selecteer subtaken",
    selectSubtasksLabel: "Selecteer subtaken:",
    selected: "geselecteerd",
    selectedVariantLabel: "Geselecteerde variant: {value}",
    selectedSubtasksLabel: "Geselecteerde subtaken: {value}",
    definedTaskSelected: "Ik zie dat u een vooraf gedefinieerde taak heeft geselecteerd",
    subtaskSelectionInstruction: "Selecteer alle taken die u heeft uitgevoerd uit de dropdownlijst, of beschrijf ze in detail in de chat. Als u niet zeker bent, maak u geen zorgen. U kunt ze later toevoegen en verwijderen.",
    wellDefinedTasksListHeader: "Hier zijn de goed gedefinieerde taken die je kunt gebruiken:",
    wellDefinedTasksListFooter: "Je kunt deze taaknamen direct gebruiken bij het indienen van je werk.",
    wellDefinedTasksAre: "De goed gedefinieerde taken zijn:",
    changeLanguage: "Taal wijzigen",
    toggleTheme: "Thema wisselen",
    assistant: "Assistent",
    typeMessage: "Typ je bericht...",
    employee: "Medewerker",
    online: "Online",
    todaysTasks: "Taken en conversatievoor vandaag",
    logout: "Uitloggen",
    settings: "Instellingen",
    assistantWelcome: "Hallo! Ik ben je AI-assistent. Hoe kan ik je vandaag helpen?",
    assistantProjectHelp: "Natuurlijk! Ik kan je daarmee helpen. Welke specifieke vragen heb je over het projectmanagementsysteem?",
    assistantStepByStep: "Om een nieuw project aan te maken, ga naar het tabblad Projecten en klik op \"Nieuw project\". Daarna kun je teamleden toevoegen door op de knop \"Leden toevoegen\" te klikken. Wil je dat ik je stap voor stap door het proces leid?",
    assistantDefault: "Bedankt voor je bericht! Ik kom zo snel mogelijk bij je terug met een uitgebreid antwoord.",
    chatSubmittedNotice: "Deze chat is ingediend en kan niet meer worden gewijzigd. Wil je meer taken indienen, doe dit dan in een nieuw chatvenster. Wil je een opmerking toevoegen voor je manager, typ deze dan in de chat en typ opnieuw 'submit' om te bevestigen.",
    multipleVariantsFound: "Meerdere varianten gevonden. Selecteer de juiste:",
    extractedValues: "Geëxtraheerde waarden:",
    extractedKeywords: "Geëxtraheerde trefwoorden:",
    normalizedRequest: "Genormaliseerd verzoek:",
    amount: "Aantal",
    billing: "Facturatie",
    conversationWelcome: "Hallo! Hoe kan ik u vandaag helpen?",
    conversationTaskPrompt: "Vertel me over uw taak. Wat heeft u gedaan?",
    conversationSomethingElse: "Ik begrijp uw vraag. Voor nu focussen we op taken. Wilt u een taak indienen?",
    conversationGoodbye: "Bedankt! Tot ziens!",
    // Dialogue step messages
    conv_welcome: "Hallo! Hoe kan ik u vandaag helpen?",
    conv_help: "Hallo! 👋 Ik ben je **virtuele assistent** en ik help je bij het indienen van je werktaken.<br><br>Je kunt mij vertellen welke taken je tijdens je werkdag hebt uitgevoerd.<br><br>➡️ Houd het eenvoudig: <em>één taak per zin</em> werkt het beste (al mag je ook meerdere taken tegelijk indienen).<br><br>Nadat je de taak of taken hebt ingevoerd, haal ik de belangrijkste details eruit, herschrijf ik ze in duidelijke zinnen en vraag ik je om bevestiging. Ik kan ook nog een paar vervolgvragen stellen.<br><br>✅ Aan het einde worden je taken weergegeven in een <strong>tabel</strong> voor een laatste bevestiging.<br><br>Zodra je dit goedkeurt, sluit het gesprek en start een nieuwe sessie — zodat alles duidelijk en overzichtelijk blijft.<br><br>✨ Rechtsboven vind je 3 handige opties:<br>- 🌍 Klik op de <strong>taalknop</strong> om te wisselen tussen Nederlands en Engels.<br>- 🔊 Klik op de <strong>sprekerknop</strong> om de berichten hardop voor te laten lezen.<br>- 🌙☀️ Klik op het <strong>maan-/zonpictogram</strong> om te wisselen tussen donker en licht thema.<br><br>🎤 Als je liever spreekt in plaats van typt, klik dan op de <strong>microfoonknop</strong> om te beginnen met praten, en klik opnieuw wanneer je klaar bent. Mogelijk moet je in je browser microfoontoegang toestaan.<br><br>🔄 <strong>Opnieuw beginnen nodig?</strong> Je kunt het gesprek op elk moment resetten door te typen: <em>start over</em>, <em>try again</em>, <em>reset</em>, <em>opnieuw instellen</em>, <em>opnieuw beginnen</em>, <em>cancel</em>, <em>annuleren</em>, <em>TA</em>, of <em>OB</em>.<br><br>📞 Als je vragen hebt of een bug wilt melden, neem dan contact op via <strong>+31 6 XXXXXXXX</strong>.",
    conv_task_request: "Beschrijf alstublieft de taken die u hebt voltooid.",
    conv_task_simple_splitting_and_confirmation: "Ik heb uw taken verwerkt. Hier is wat ik vond:",
    conv_task_processing: "Uw taken worden verwerkt...",
    are_there_more_tasks: "We hebben die taken al verwerkt. Heeft u nog meer taken om in te dienen?",
    assignement_additional_comments:
      "Heeft u nog aanvullende opmerkingen over deze opdracht? Typ ze hier, of bevestig dat er niets toe te voegen is door OK te typen.",
    final_confirmation: "Bevestig alstublieft dat alle bovenstaande taken correct zijn voordat we doorgaan.",
    user_requests_correction: "Ik begrijp dat u wilt aanpassingen maken.",
    conv_something_else: "Deze functie is in ontwikkeling. Voor urgente zaken, neem contact op via +31 6 XXXXX",
    conv_bye: "Bedankt! Tot ziens!",
    userRequestsCorrectionInstruction: "Als u een taak wilt verwijderen, zeg dan welke taak verwijderd moet worden. Als u een taak wilt toevoegen, doe dit dan in een nieuw gesprek. Als u het aantal, aantal medewerkers of locatie wilt wijzigen, geef dan aan welke wijziging moet worden gemaakt en voor welke taak.",
    variantSelectionPrompt: "Welke optie past bij jouw taak?",
    billingUnitHours: "De facturatie-eenheid voor deze taak is uren.\nHoeveel uren zijn er besteed aan deze taak?",
    billingUnitMeters: "De facturatie-eenheid voor deze taak is meters.\nHoeveel meter is er gewerkt?",
    billingUnitPieces: "De facturatie-eenheid voor deze taak is stuks.\nHoeveel stuks zijn er gebruikt?",
    billingUnitGeneric: "Hoeveel eenheden zijn er gebruikt voor deze taak?",
    billingUnitFallback: "Hoeveel is er gebruikt voor deze taak?",
    // Specific question rules
    billingUnitHourEmployee: "De facturatie-eenheid voor deze taak is uren.\nHoe lang heeft de medewerker gewerkt?",
    billingUnitHourTeam: "De facturatie-eenheid voor deze taak is uren.\nHoe lang heeft het team gewerkt?",
    billingUnitHourEquipment: "De facturatie-eenheid voor deze taak is uren.\nHoe lang heeft u deze apparatuur gebruikt?",
    billingUnitStTreeRemove: "De facturatie-eenheid voor deze taak is stuks.\nHoeveel bomen heeft u verwijderd?",
    billingUnitStPipeRemove: "De facturatie-eenheid voor deze taak is stuks.\nHoeveel leidingen heeft u verwijderd?",
    billingUnitStPipeInstall: "De facturatie-eenheid voor deze taak is stuks.\nHoeveel leidingen heeft u geïnstalleerd?",
    billingUnitMPipeRemove: "De facturatie-eenheid voor deze taak is meter leiding.\nHoeveel meter leiding heeft u verwijderd?",
    billingUnitMPipeInstall: "De facturatie-eenheid voor deze taak is meter leiding.\nHoeveel meter leiding heeft u geïnstalleerd?",
    billingUnitMGeneric: "De facturatie-eenheid voor deze taak is meters.\nHoeveel meter is er gebruikt/verwerkt?",
    billingUnitArea: "De facturatie-eenheid voor deze taak is oppervlakte.\nWat was het oppervlak?",
     billingUnitVolume: "De facturatie-eenheid voor deze taak is volume.\nWat was het volume?",
     taskCompleted: "Taak succesvol voltooid!",
     processingNextTask: "Volgende taak wordt verwerkt: {taskDescription}",
     processingTaskNow: "Ik verwerk de taak \"{taskDescription}\" nu.",
     chooseItemMatchesTask: "Kies het item dat overeenkomt met je taak",
     conversationSubmitted: "Gesprek ingediend",
     tasksCompletedSingle: "Ik zie dat je 1 taak hebt gedaan:",
     tasksCompletedMultiple: "Ik zie dat je {count} taken hebt gedaan:",
     confirmOrRetypeTasks: "Bevestig of typ de taken opnieuw.",
     conversationSubmittedNotice: "Dit gesprek is ingediend. U kunt een nieuw gesprek beginnen.",
     location_clarification: "Waar is deze taak voltooid? Geef alstublieft een exact adres op.",
     taskLocationFromAssignementFallback: "Werklocatie (opdracht)",
     something_else_message: "Het spijt me, ik begreep dat niet. Probeer het opnieuw.",
     // Task confirmation messages
     thankYouForSubmitting: "Bedankt voor het indienen van je taken. Controleer of de samenvatting hieronder correct is:",
     noCompletedTasksFound: "Geen voltooide taken gevonden om weer te geven.",
     doYouConfirm: "Bevestig je dit?",
     gotThat: "Begrepen!",
     // Task summary UI
     taskSummary: "Taak Samenvatting",
     reviewCompletedTasks: "Bekijk de voltooide taken hieronder:",
     // Measurement terms
     diameter: "diameter",
     height: "hoogte", 
     depth: "diepte",
     length: "lengte",
     area: "oppervlakte",
     size: "grootte",
     // Speech-to-text
     startVoiceInput: "Start spraakinvoer",
     stopListening: "Stop opname",
     voiceInputNotSupported: "Microfoon toegang geweigerd. Sta microfoon toegang toe om spraakinvoer te gebruiken.",
     processingAudio: "Audio wordt verwerkt...",
     audioUploadError: "Fout bij het verwerken van audiobestand. Probeer het opnieuw.",
     recording: "Opname... Klik om te stoppen",
     // Emergency submission
     emergency_submit_message: "Je hebt de noodzakelijke indieningsfunctie gebruikt. Uw taak wordt ingediend zoals is. Bedankt!",
     // Abort confirmation
     abort: "Gesprek afbreken",
     areYouSureYouWantToAbort: "Weet je zeker dat je wilt afbreken?",
     // Task modification confirmations
     deleteTaskConfirmation: "Ik begrijp dat je een taak wilt verwijderen. Geef alstublieft aan welke taak verwijderd moet worden.",
     changeTaskConfirmation: "Ik begrijp dat je een taak wilt wijzigen. Geef alstublieft aan welke wijzigingen moeten worden gemaakt en voor welke taak.",
     // Feature development messages
     featureInDevelopment: "Deze functie is momenteel in ontwikkeling en zal functioneel zijn in de volgende versie! Voorlopig kun je ervan uitgaan dat we je feedback hebben begrepen, ook al kun je de wijziging niet zien.",
     pleaseConfirmToContinue: "Typ alstublieft \"Ik bevestig\" om door te gaan.",
    // Conversation cancellation
    conversationCancelled: "Je hebt gevraagd om dit gesprek te annuleren. Start alstublieft in een nieuw venster!",
    // Missing state keys
    delete_a_task: "Ik begrijp dat je een taak wilt verwijderen. Geef alstublieft aan welke taak verwijderd moet worden.",
    change_a_task: "Ik begrijp dat je een taak wilt wijzigen. Geef alstublieft aan welke wijzigingen moeten worden gemaakt en voor welke taak.",
    processing_options_selection: "Je taak wordt verwerkt...",
    no_tasks_found: "Ik kon geen taken vinden in je bericht. Probeer je taak duidelijker te beschrijven.",
    variant_selection: "Welke optie past bij jouw taak?",
    amount_clarification: "Hoeveel is er gebruikt voor deze taak?",
    abort_confirmation: "Weet je zeker dat je wilt afbreken?",
    abortCancelled: "Afbreken geannuleerd. Laten we verdergaan waar we gebleven waren.",
    abortConfirmed: "Oké, ik stop dit gesprek. Je kunt een nieuw gesprek starten wanneer je klaar bent.",
    task_completed: "Taak succesvol voltooid!",
    task_aborted: "Taakverwerking werd afgebroken.",
    // Well-defined tasks
    well_defined_task_property_connection: "perceelaansluiting",
    well_defined_task_manhole_replacement: "kolk vervangen",
    well_defined_task_manhole_connection_replacement: "kolk aansluitleiding vervangen",
    well_defined_task_hole_subsidence: "gat-verzakking",
    well_defined_task_main_sewer: "hoofdriolering",
    well_defined_task_drainage: "drainage",
    well_defined_task_clean_manholes: "reinigen kolken",
    // Subtasks (keep numeric IDs as part of the key) - Dutch translations
    subtask_141: "Asfalt opbreken",
    subtask_142: "Opbreken betonstraatstenen",
    subtask_143: "Straatklinker opbreken",
    subtask_144: "Betontegel opbreken",
    subtask_145: "Tegelrand opbreken",
    subtask_146: "Goot opbreken",
    subtask_147: "Extra werk",
    subtask_149: "Fundering opbreken",
    subtask_147110: "Aarde verwijderen van bestratingsmateriaal",
    subtask_151: "Aanbrengen, Toepassen, Verwijderen, onderhouden open drainage",
    subtask_181: "Beton- en PVC-buizen verwijderen",
    subtask_182: "Drainagebuizen verwijderen",
    subtask_183: "Kolken/putten verwijderen/onderhouden",
    subtask_184: "Kolken/vuilwaterputten verwijderen/onderhouden",
    subtask_185010: "Verwijdering van bakstenen keermuur",
    // Task-specific subtasks - Dutch translations
    subtask_154: "Installatie van afsluiters",
    subtask_155: "Spoelen van drainagebuizen",
    subtask_163: "Grondverzet (Huis- en kolk aansluitingen, drukbuis, drainage)",
    subtask_164: "Grondverzet (Bekisting - Steunbekisting rioolgoot, dubbelzijdig met verschillende hoogtes)",
    subtask_1558: "Kolken/vuilwaterputten reinigen",
    // New subtasks - Dutch translations
    subtask_24: "Installatie van drainage kolk / putten",
    subtask_211: "installatie van leidingen - buizen",
    subtask_212: "Installatie van leidingen - Huis- en kolk / put aansluitingen",
    subtask_214: "installatie van drainagebuizen",
    subtask_221: "Installatie van leidingen - Betonnen kolk / putten",
    subtask_222: "Installatie van leidingen - Kunststof putten",
    subtask_223: "Installatie van leidingen - kolk / put aanpassingen",
    subtask_224: "Installatie van leidingen - Putranden",
    subtask_228010: "Meten van putten",
    subtask_231: "verwerking van zand en grond - Hoofdriolering en duikers",
    subtask_232: "verwerking van zand/grond - Huis- en drainage kolk / put aansluitingen, drukbuis",
    subtask_233: "Drainage begeleiding - vullen van sleuven",
    subtask_243: "Bevestigen van geur afdichting en vervangen van deksel pin",
    subtask_251: "Rioolinspectie - buizen",
    subtask_260010: "Repareren en herstellen van lekken en andere schade binnen rioleringssystemen",
    subtask_343: "Installatie van betontegels",
    subtask_344: "Installatie van straatstenen",
    subtask_345: "Installatie van betonstraatstenen",
    // Subtask processing messages - Dutch
    processingSubtaskNow: "Ik verwerk de taak \"{taskDescription}\" nu. Geef alstublieft de gevraagde informatie op.",
    pleaseProvideAmountForTask: "Geef alstublieft het aantal voor uw taak op (eenheid: {unit})",
    pleaseSelectVariantForTask: "Selecteer alstublieft een variant voor \"{taskDescription}\":",
    pleaseSelectVariantForSubtask: "Selecteer alstublieft een variant voor subtask {subtaskId}:",
    pleaseSelectMostFittingDescription: "Selecteer alstublieft de meest passende beschrijving voor \"{subtaskDescription}\":",
    pleaseSelectMostFittingDescriptionForSubtask: "Selecteer alstublieft de meest passende beschrijving voor subtask {subtaskId}:",
    taskIdDescription: "Taak ID: {taskId}\nBeschrijving: {description}\nGelijkenis: 1.0",
    couldYouPleaseClarify: "Kunt u alstublieft verduidelijken wat u wilt doen?",
    taskSplittingError: "Sorry, ik had problemen met het verwerken van uw taken: {error}. Probeer het alstublieft opnieuw.",
    // Table headers - Dutch
    taskDescription: "Taak Beschrijving",
    id: "ID",
    billableUnit: "b. eenheid",
    billableAmount: "b. bedrag",
    employees: "Medewerkers",
    location: "Locatie",
    removeTask: "Taak verwijderen",
    noCompletedTasksToDisplay: "Geen voltooide taken om weer te geven.",
    // Text-to-speech - Dutch
    textToSpeechOnlyAvailableInDutch: "Tekst-naar-spraak is alleen beschikbaar in het Nederlands",
    disableTextToSpeech: "Tekst-naar-spraak uitschakelen",
    enableTextToSpeech: "Tekst-naar-spraak inschakelen",
    // Invoice generation - Dutch
    failedToGenerateInvoice: "Factuur genereren mislukt",
    errorGeneratingInvoice: "Fout bij het genereren van factuur",
    // Accessibility - Dutch
    closeSidebar: "Zijbalk sluiten",
    assignementAddressTitle: "Adres opdracht",
    assignementAddressPrompt:
      "Vul het werkadres voor deze opdracht in. Dit wordt gebruikt als standaardlocatie voor taken binnen deze opdracht.",
    assignementAddressPlaceholder: "Straat, nummer, postcode, plaats",
    assignementSaveAddress: "Opslaan",
    assignementCancel: "Annuleren",
    assignementNew: "Nieuwe opdracht",
    assignementMarkComplete: "Opdracht voltooien",
    assignementCompleted: "Voltooid",
    assignementChats: "Gesprekken",
    assignementUnassigned: "Overig (geen opdracht)",
    assignementNumber: "Opdracht {n}",
    addCommentsOnly: "Alleen opmerkingen toevoegen",
    // Variant selector - Dutch
    defaultOption: "Standaard Optie",
    // Server busy message - Dutch
    serverBusyRetrying: "De server is momenteel erg druk, het kan langer duren dan normaal. Even geduld...",
    // Add more keys as needed
  }
};

export type Lang = 'en' | 'nl';

export function t(lang: Lang, key: keyof typeof translations['en'], params?: Record<string, string | number>) {
  let text = translations[lang][key] || key;
  
  // Replace placeholders like {taskDescription}, {unit}, etc.
  if (params) {
    Object.keys(params).forEach(paramKey => {
      const placeholder = `{${paramKey}}`;
      text = text.replace(new RegExp(placeholder.replace(/[{}]/g, '\\$&'), 'g'), String(params[paramKey]));
    });
  }
  
  return text;
}

export type TranslationKey = keyof typeof translations['en']; 